/**
 * Application version configuration
 * Reads from environment variable VITE_APP_VERSION
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '1.0.0';

/**
 * Get formatted version string
 */
export const getVersionString = (): string => {
  const version = APP_VERSION;
  return version.startsWith('v') ? version : `v${version}`;
};
